// Theme

const theme = {
  font: {
    primary: `'Open Sans', sans-serif`,
    secondary: `Red Hat Display, sans-serif`,
    light: `Red Hat Display, sans-serif`,
    normal: `Red Hat Display Medium, sans-serif`,
    medium: `Red Hat Display Medium, sans-serif`,
    semibold: `Red Hat Display Bold, sans-serif`,
    bold: `Red Hat Display Bold, sans-serif`,
    extrabold: `Red Hat Display Bold, sans-serif`,
  },
  font_size: {
    xxxsmall: "font-size: 12px;",
    xxsmall: "font-size: 14px;",
    xsmall: "font-size: 16px;",
    small: "font-size: 17px;",
    regular: "font-size: 22px; line-height: 35px;",
    large: "font-size: 28px; line-height: 35px;",
    larger: "font-size: 40px; line-height: 50px;",
    xlarge: "font-size: 72px; line-height: 72px;",
  },
  animation: {
    regular: "transition: 0.6s cubic-bezier(0.2, 0.8, 0.2, 1);",
  },
  color: {
    primary: "#071435",
    /*primary: "#00ff00",
    secondary: "#C0392B",*/
    secondary: "#cca86e",
    accent: "#B90B0B",
    error: "#ef0d33",
    background: {
      white: "#ffffff",
      light: "#f8f8f8",
    },
    white: {
      regular: "#ffffff",
      lessdark: "#faf9f8",
      dark: "#f6f6f6",
      darker: "#eeeeee",
    },
    black: {
      lightest: "#ABA8AF",
      light: "#564F62",
      regular: "#000000",
    },
  },
  screen: {
    xs: "575px",
    sm: "767px",
    md: "991px",
    lg: "1199px",
  },
}

export default theme
